import React from 'react';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
	title: {
		fontWeight: 'bold'
	},
	content: {
		opacity: '50%'
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginTop: 50,
		justifyContent: 'center',
	}
}));

const ErrorPage = ({ errorMessage, errorCode }) => {
	const classes = useStyles();
	const code = errorCode || 404;
	const content = errorMessage || 'Page not found';

	return (
		<Typography variant='h2' className={classes.container}>
			<span className={classes.title}>Oops, something went wrong!</span>
			<span className={classes.content}>{code} - {content}</span>
		</Typography>
	);
};

export default ErrorPage;
